module.exports = __webpack_public_path__ + "img/red.f62b621d.png";